import MapBaseController from './map_base_controller'

class MapGeofencesController extends MapBaseController {
  static values = {
    id: String,
    displayOnly: Boolean
  };

  initialize () {
    super.initialize()
    this.state = 'drag-map'
    this.fence = false
    this.editing = false
    this.shapes = []
    this.buildMap()
    this.loadPoints(this.idValue)
  }

  connect () {
    const instance = this

    $(document).on('click', '[data-state]', function (e) {
      e.preventDefault()
      const cssClass = 'geofence-controls__item__link--active'
      const state = $(this).attr('data-state')
      $('[data-state]').removeClass(cssClass)
      $(this).addClass(cssClass)
      instance.toggleState(state)
    })
  }

  buildMap () {
    this.map = L.mapbox.map(this.element, null, {
      zoomControl: false,
      attributionControl: { compact: true }
    })

    this.map.addLayer(
      L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11')
    )

    this.addControls(!this.displayOnlyValue)

    if (this.state === 'drag-map' && !this.displayOnlyValue) {
      this.enableDragging()
    }

    const instance = this

    this.map.on('mousedown', function (e) {
      if (instance.state !== 'draw-boundary') return
      instance.drawing = true
      instance.drawStart(e.latlng)
    })

    this.map.on('mousemove', function (e) {
      if (instance.state !== 'draw-boundary') return
      if (instance.drawing) instance.drawMove(e.latlng)
    })

    this.map.on('mouseup', function () {
      if (instance.state !== 'draw-boundary') return
      instance.drawing = false
      instance.drawEnd()
    })

    const getTouchLatLng = (event) => {
      const touch = event.touches[0]
      const mapOffset = instance.map._container

      if (!touch) return

      const point = L.point(
        touch.clientX - mapOffset.offsetLeft,
        touch.clientY - mapOffset.offsetTop
      )
      return instance.map.containerPointToLatLng(point)
    }

    this.map._container.addEventListener(
      'touchstart',
      function (e) {
        if (instance.state !== 'draw-boundary') return
        instance.drawing = true
        instance.drawStart(getTouchLatLng(e))
      },
      false
    )

    this.map._container.addEventListener(
      'touchmove',
      function (e) {
        if (instance.state !== 'draw-boundary') return
        if (instance.drawing) instance.drawMove(getTouchLatLng(e))
      },
      false
    )

    this.map._container.addEventListener(
      'touchend',
      function (e) {
        if (instance.state !== 'draw-boundary') return
        instance.drawing = false
        instance.drawEnd()
      },
      false
    )
  }

  disableMapInteractions () {
    this.map.dragPan.disable()
    this.map.doubleClickZoom.disable()
  }

  enableMapInteractions () {
    this.map.dragPan.enable()
    this.map.doubleClickZoom.enable()
  }

  loadPoints (points) {
    const instance = this

    $.ajax({
      url: '/safety/monitored_by_you/' + points + '/location/points',
      success: function (data) {
        if (data.exist) {
          instance.addGeofence(data.points)
          $('[name="settings[points]"]').val(data.points)
          $('#locationControl').removeClass('hidden')
          instance.hideLoader()
        } else {
          $('#locationControl').addClass('hidden')
          instance.centerLocation()
        }
      }
    })
  }

  addGeofence (points) {
    const splitPoints = []
    points = points.split('/')

    $.each(points, function (_, v) {
      splitPoints.push({
        lat: parseFloat(v.split(',')[0]),
        lng: parseFloat(v.split(',')[1])
      })
    })

    // add the fence to the map
    this.fence = L.polyline(splitPoints, {
      fill: 'true',
      fillColor: '#0083B9',
      color: '#0083B9',
      weight: 4,
      noClip: true
    }).addTo(this.map)

    // add the fence to shapes
    this.shapes[0] = this.fence

    // focus on the new fence
    this.map.fitBounds(this.fence.getBounds(), { padding: [40, 40] })
    this.hideLoader()
  }

  enableDragging () {
    this.map.dragging.enable()
    this.map.touchZoom.enable()
    this.map.doubleClickZoom.enable()
    this.map.scrollWheelZoom.enable()
    this.map.boxZoom.enable()

    $('.leaflet-control-zoom.leaflet-bar.leaflet-control').show()

    if (this.map.tap) this.map.tap.enable()
  }

  disableDragging () {
    this.map.dragging.disable()
    this.map.touchZoom.disable()
    this.map.doubleClickZoom.disable()
    this.map.scrollWheelZoom.disable()
    this.map.boxZoom.disable()

    $('.leaflet-control-zoom.leaflet-bar.leaflet-control').hide()

    if (this.map.tap) this.map.tap.disable()
  }

  clearMap () {
    // remove each shape from the map
    const instance = this

    $.each(this.shapes, function (_, v) {
      instance.map.removeLayer(v)
    })

    // clear the shapes
    this.shapes = []

    $('[name="settings[points]"]').val('')

    $('#locationControl').addClass('hidden')
  }

  drawStart (latlng) {
    // create the fence
    this.fence = L.polyline(latlng, {
      color: '#0083B9',
      weight: 4,
      noClip: true
    }).addTo(this.map)
  }

  drawMove (latlng) {
    // add points to the fence
    if (this.fence) this.fence.addLatLng(latlng)
  }

  drawEnd () {
    // remove the fence if the points are less than 15
    if (this.fence.getLatLngs().length < 15) {
      this.map.removeLayer(this.fence)
      $('#locationControl').addClass('hidden')
      return true
    }

    // make sure the fence ends where it started
    this.fence.addLatLng(this.fence.getLatLngs()[0])

    // simplify the fence using the Douglas Peucker algorithm
    let filteredPoints = []
    filteredPoints = this.peuckerFilteredPoints(
      this.fence.getLatLngs(),
      0.0000001
    )
    // re-add the start so it ends where it started (is this required? as we added it already!)
    filteredPoints.push(filteredPoints[0])
    // set the fence to use the filteredPoints instead
    this.fence.setLatLngs(filteredPoints)

    // fill the fence
    this.fence.setStyle({
      fill: true,
      fillColor: '#0083B9'
    })

    // add the fence to shapes
    this.shapes.push(this.fence)

    // trigger click of drag map
    $('[data-state="drag-map"]').trigger('click')

    $('[name="settings[points]"]').val(this.getFenceLatLngs())

    if ($('[name="settings[points]"]').val() !== '') {
      $('#locationControl').removeClass('hidden')
    }
  }

  toggleState (state) {
    this.state = state

    switch (state) {
      case 'drag-map':
        this.enableDragging()
        break
      case 'draw-boundary':
        this.clearMap()
        this.disableDragging()
        break
      case 'clear':
        this.clearMap()
        // trigger click of draw boundary
        $('[data-state="draw-boundary"]').trigger('click')
        break
      default:
    }
  }

  getFenceLatLngs () {
    if (!this.shapes[0]) return ''

    let latlngs = ''

    $.each(this.shapes[0].getLatLngs(), function (_, v) {
      if (latlngs !== '') latlngs += '/'

      latlngs += v.lat + ',' + v.lng
    })

    return latlngs
  }

  centerLocation () {
    this.map.setView([38.20365531807149, -97.6025390625], 5)

    this.map.locate()
    const instance = this

    this.map.on('locationfound', function (e) {
      instance.map.setView([e.latitude, e.longitude], 11)
      instance.hideLoader()
    })

    this.map.on('locationerror', function () {
      console.log('ERROR')
      instance.hideLoader()
    })
  }

  fitInBounds () {
    this.map.invalidateSize()

    if (this.fence) {
      this.map.fitBounds(this.fence.getBounds(), { padding: [40, 40] })
    }
  }

  peuckerFilteredPoints (points, epsilon) {
    let i
    let maxIndex = 0
    let maxDistance = 0
    let perpendicularDistance
    let leftRecursiveResults
    let rightRecursiveResults
    let filteredPoints

    // find the point with the maximum distance
    for (i = 2; i < points.length - 1; i++) {
      perpendicularDistance = this.findPerpendicularDistance(points[i], [
        points[1],
        points[points.length - 1]
      ])
      if (perpendicularDistance > maxDistance) {
        maxIndex = i
        maxDistance = perpendicularDistance
      }
    }
    // if max distance is greater than epsilon, recursively simplify
    if (maxDistance >= epsilon) {
      leftRecursiveResults = this.peuckerFilteredPoints(
        points.slice(1, maxIndex),
        epsilon
      )
      rightRecursiveResults = this.peuckerFilteredPoints(
        points.slice(maxIndex),
        epsilon
      )
      filteredPoints = leftRecursiveResults.concat(rightRecursiveResults)
    } else {
      filteredPoints = points
    }
    return filteredPoints
  }

  findPerpendicularDistance (point, line) {
    const pointCoords = this.map.latLngToContainerPoint(
      L.latLng(point.lat, point.lng)
    )
    const line1Coords = this.map.latLngToContainerPoint(
      L.latLng(line[0].lat, line[0].lng)
    )
    const line2Coords = this.map.latLngToContainerPoint(
      L.latLng(line[1].lat, line[1].lng)
    )

    const pointX = pointCoords.x
    const pointY = pointCoords.y
    const lineStart = {
      x: line1Coords.x,
      y: line1Coords.y
    }
    const lineEnd = {
      x: line2Coords.x,
      y: line2Coords.y
    }
    const slope = (lineEnd.y - lineStart.y) / (lineEnd.x - lineStart.x)
    const intercept = lineStart.y - slope * lineStart.x
    const result =
      Math.abs(slope * pointX - pointY + intercept) /
      Math.sqrt(Math.pow(slope, 2) + 1)

    return result
  }
}

export default MapGeofencesController
